(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var isSmart = header.classList.contains('site-header--smart');
    var isTransparent = header.classList.contains('site-header--transparent');
    var isSticky = header.classList.contains('site-header--sticky');

    if (!isSmart && !isTransparent) return;

    var lastScrollY = window.scrollY;
    var scrollThreshold = 80;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    function update() {
      var scrollY = window.scrollY;

      // Transparent: reveal background once scrolled past a few pixels
      // Only applies when header is sticky — if sticky mode is none, header scrolls away anyway
      if (isTransparent && (isSticky || isSmart)) {
        if (scrollY > 10) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
      }

      // Smart: hide on scroll down, reveal on scroll up
      if (isSmart) {
        if (scrollY > lastScrollY && scrollY > scrollThreshold) {
          header.classList.add('is-hidden');
        } else if (scrollY < lastScrollY) {
          header.classList.remove('is-hidden');
        }
      }

      lastScrollY = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  (function() {
    var drawer  = document.querySelector('[data-search-drawer]');
    var input   = document.getElementById('search-drawer-input');
    var results = document.getElementById('search-drawer-results');
    var links   = document.getElementById('search-drawer-links');
    var clearBtn = document.getElementById('search-drawer-clear');
    if (!drawer) return;

    var debounceTimer = null;
    var currentQuery  = '';

    /* ── Format money ── */
    function formatMoney(val) {
      if (val == null) return '';
      // Predictive Search API returns prices as decimal strings (e.g. "29.99")
      // already in the store's currency unit — not cents. Parse directly.
      var amount = parseFloat(val);
      if (isNaN(amount)) return '';
      var formatted = amount.toFixed(2);
      if (window.Shopify && Shopify.money_format) {
        return Shopify.money_format
          .replace('{{amount}}', formatted)
          .replace('{{amount_no_decimals}}', Math.round(amount))
          .replace('{{amount_with_comma_separator}}', formatted.replace('.', ','))
          .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(amount));
      }
      return '$' + formatted;
    }

    /* ── Highlight matching query in text ── */
    function highlight(text, query) {
      if (!query) return text;
      var escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return text.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark class="search-drawer__highlight">$1</mark>');
    }

    var COLOR_MAP = {
      black:'#111111', white:'#ffffff', red:'#e53e3e', blue:'#3182ce',
      navy:'#1a3a5c', green:'#38a169', olive:'#6b7c3a', yellow:'#ecc94b',
      orange:'#ed8936', pink:'#ed64a6', purple:'#805ad5', violet:'#805ad5',
      grey:'#9e9e9e', gray:'#9e9e9e', brown:'#8b5e3c', tan:'#c8a882',
      cream:'#fffdd0', ivory:'#fffff0', beige:'#d4c5a9', sand:'#c2b280',
      khaki:'#c3b091', teal:'#319795', cyan:'#00bcd4', lime:'#9acd32',
      maroon:'#800000', burgundy:'#800020', wine:'#722f37', rust:'#b7410e',
      camel:'#c19a6b', stone:'#8e8e78', slate:'#708090', silver:'#c0c0c0',
      gold:'#ffd700', copper:'#b87333', coral:'#ff7f7f', mint:'#98ff98',
      lavender:'#e6e6fa', lilac:'#c8a2c8', rose:'#ff007f', mauve:'#e0b0ff',
      charcoal:'#36454f', ecru:'#c2b280', denim:'#1560bd', indigo:'#4b0082',
      forest:'#228b22', sage:'#b2ac88', taupe:'#483c32', blush:'#ff6e7f',
      cobalt:'#0047ab', scarlet:'#ff2400', chocolate:'#7b3f00', espresso:'#3c1a0d',
      plum:'#8e4585', magenta:'#ff00ff', fuchsia:'#ff00ff', mustard:'#ffdb58',
      mocha:'#967259', nude:'#e8cbb0', multi:'linear-gradient(135deg,#e53e3e,#3182ce,#38a169)'
    };

    function colorFromName(name) {
      if (!name) return null;
      var lower = name.toLowerCase().trim();
      // exact match first
      if (COLOR_MAP[lower]) return COLOR_MAP[lower];
      // match first word (e.g. "Forest Green" → "forest")
      var first = lower.split(/[\s\/\-_]+/)[0];
      if (COLOR_MAP[first]) return COLOR_MAP[first];
      // match any word in the name
      var words = lower.split(/[\s\/\-_]+/);
      for (var i = 0; i < words.length; i++) {
        if (COLOR_MAP[words[i]]) return COLOR_MAP[words[i]];
      }
      return null;
    }

    function isLight(hex) {
      if (!hex || hex.indexOf('gradient') !== -1) return false;
      var c = hex.replace('#','');
      if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
      var r = parseInt(c.substr(0,2),16), g = parseInt(c.substr(2,2),16), b = parseInt(c.substr(4,2),16);
      return (r*299 + g*587 + b*114) / 1000 > 210;
    }

    function buildSwatchesHtml(product) {
      var swatches = product._swatches;
      if (!swatches || !swatches.length) return '';

      var MAX_SWATCHES = parseInt(drawer.getAttribute('data-swatch-max')) || 6;
      var shown = swatches.slice(0, MAX_SWATCHES);
      var extra = swatches.length - shown.length;

      var html = '<div class="search-drawer__result-swatches">';
      shown.forEach(function(s) {
        var imgAttr = s.img ? ' data-img="' + s.img + '"' : '';
        if (s.i) {
          html += '<span class="search-drawer__swatch"' + imgAttr + ' style="background-image:url(' + s.i + ');background-size:cover;" title="' + s.v + '"></span>';
        } else if (s.c) {
          var lightClass = isLight(s.c) ? ' search-drawer__swatch--light' : '';
          html += '<span class="search-drawer__swatch' + lightClass + '"' + imgAttr + ' style="background:' + s.c + ';" title="' + s.v + '"></span>';
        } else {
          var fallback = colorFromName(s.v);
          if (fallback) {
            var lightClass2 = isLight(fallback) ? ' search-drawer__swatch--light' : '';
            html += '<span class="search-drawer__swatch' + lightClass2 + '"' + imgAttr + ' style="background:' + fallback + ';" title="' + s.v + '"></span>';
          }
        }
      });
      if (extra > 0) {
        html += '<span class="search-drawer__swatch-more">+' + extra + '</span>';
      }
      html += '</div>';
      return html;
    }

    /* ── Render results ── */
    function renderResults(products, query) {
      if (!results) return;
      results.innerHTML = '';
      if (!products || products.length === 0) {
        results.innerHTML = '<p class="search-drawer__no-results">No results for \u201c' + query + '\u201d</p>';
        return;
      }
      var label = document.createElement('p');
      label.className = 'search-drawer__results-label';
      label.textContent = drawer.getAttribute('data-label-text') || 'Products';
      results.appendChild(label);

      products.forEach(function(p) {
        var a = document.createElement('a');
        a.className = 'search-drawer__result-item';
        a.href = p.url;

        var imgHtml = p.featured_image && p.featured_image.url
          ? '<img class="search-drawer__result-img" src="' + p.featured_image.url + '&width=160" alt="' + (p.featured_image.alt || p.title) + '" width="80" height="80" loading="lazy" style="opacity:0;transition:opacity 0.3s ease;" onload="this.style.opacity=1" onerror="this.style.opacity=1">'
          : '<div class="search-drawer__result-img-placeholder"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" opacity=".3"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21,15 16,10 5,21"/></svg></div>';

        var price = '';
        if (p.price_min != null) {
          price = formatMoney(p.price_min);
          if (p.price_max && p.price_max !== p.price_min) {
            price += ' \u2013 ' + formatMoney(p.price_max);
          }
        }

        var swatchesHtml = buildSwatchesHtml(p);

        a.innerHTML = imgHtml +
          '<div class="search-drawer__result-info">' +
            '<div class="search-drawer__result-title-row">' +
              '<div class="search-drawer__result-title">' + highlight(p.title, query) + '</div>' +
              (price ? '<div class="search-drawer__result-price">' + price + '</div>' : '') +
            '</div>' +
            swatchesHtml +
          '</div>';
        results.appendChild(a);
      });

      /* View all link */
      var footer = document.createElement('div');
      footer.className = 'search-drawer__results-footer';
      footer.innerHTML = '<a href="/search?type=product&q=' + encodeURIComponent(query) + '">' + (drawer.getAttribute('data-viewall-text') || 'View all results') + '</a>';
      results.appendChild(footer);
    }

    /* ── Fetch from Shopify Predictive Search API ── */
    function fetchResults(query) {
      if (!query || query.length < 1) {
        results.innerHTML = '';
        if (links) links.classList.remove('is-hidden');
        return;
      }
      if (links) links.classList.add('is-hidden');
      results.innerHTML = '<div class="search-drawer__spinner"></div>';

      var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=8&resources[options][prefix]=last';

      fetch(url, { headers: { 'Content-Type': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products : [];
          if (!products.length) { renderResults(products, query); return; }

          /* Fetch Liquid-rendered swatch data in parallel (only way to access native Shopify swatch metafields) */
          var handleFetches = products.map(function(p) {
            var handle = p.url && p.url.split('/products/')[1]
              ? p.url.split('/products/')[1].split('?')[0].split('#')[0]
              : null;
            if (!handle) return Promise.resolve(null);
            return fetch('/products/' + handle + '?view=search-swatches')
              .then(function(r) { return r.text(); })
              .then(function(text) {
                try { return JSON.parse(text.trim()); }
                catch(e) { return null; }
              })
              .catch(function() { return null; });
          });

          Promise.all(handleFetches).then(function(swatchData) {
            swatchData.forEach(function(data, i) {
              if (Array.isArray(data) && data.length) products[i]._swatches = data;
            });
            renderResults(products, query);
          });
        })
        .catch(function() {
          results.innerHTML = '<p class="search-drawer__no-results">Something went wrong. Please try again.</p>';
        });
    }

    /* ── Swatch hover: swap product image ── */
    if (results) {
      results.addEventListener('mouseover', function(e) {
        var swatch = e.target.closest('.search-drawer__swatch');
        if (!swatch) return;
        var img = swatch.closest('.search-drawer__result-item') && swatch.closest('.search-drawer__result-item').querySelector('.search-drawer__result-img');
        if (!img || !swatch.dataset.img) return;
        if (!img.dataset.original) img.dataset.original = img.src;
        img.src = swatch.dataset.img;
      });
      results.addEventListener('mouseout', function(e) {
        var swatch = e.target.closest('.search-drawer__swatch');
        if (!swatch) return;
        var img = swatch.closest('.search-drawer__result-item') && swatch.closest('.search-drawer__result-item').querySelector('.search-drawer__result-img');
        if (!img || !img.dataset.original) return;
        img.src = img.dataset.original;
      });
    }

    /* ── Input handler with debounce ── */
    if (input) {
      input.addEventListener('input', function() {
        var q = input.value.trim();
        currentQuery = q;
        clearTimeout(debounceTimer);
        if (q.length < 1) {
          results.innerHTML = '';
          if (links) links.classList.remove('is-hidden');
          return;
        }
        if (links) links.classList.add('is-hidden');
        debounceTimer = setTimeout(function() { fetchResults(q); }, 200);
      });
    }

    /* ── Clear / close button ── */
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (input.value.trim().length > 0) {
          input.value = '';
          results.innerHTML = '';
          if (links) links.classList.remove('is-hidden');
          input.focus();
        } else {
          closeDrawer();
        }
      });
    }

    /* ── Open / close ── */
    function openDrawer() {
      drawer.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('drawer-is-open');
      requestAnimationFrame(function() {
        drawer.classList.add('is-open');
        var speed = parseInt(getComputedStyle(drawer).getPropertyValue('--sd-speed')) || 350;
        setTimeout(function(){ if (input) input.focus(); }, speed);
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.classList.remove('drawer-is-open');
    }

    document.addEventListener('click', function(e) {
      if (e.target.closest('.header__search')) {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      }
    });

    drawer.querySelector('[data-search-drawer-overlay]').addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* ── Shopify customizer: open drawer when section is selected ── */
    document.addEventListener('shopify:section:select', function(e) {
      if (e.detail.sectionId === drawer.closest('.shopify-section').id.replace('shopify-section-', '')) {
        openDrawer();
      }
    });
    document.addEventListener('shopify:section:deselect', function(e) {
      if (e.detail.sectionId === drawer.closest('.shopify-section').id.replace('shopify-section-', '')) {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
